export default {
  methods: {
    getRowId: function(row) {
      if(row.patientId) {
        return row.id + '_' + row.patientId;
      }
      return row.id;
    },
    deleteRow: function(data, index) {
      this.$swal({
        icon: 'warning',
        title: this.$t('Предупреждение'),
        text: this.$t('Вы уверены, что хотите удалить эту запись?'),
        buttons: [this.$t('Нет'), this.$t('Да')],
        }).then((willDelete) => {
          if (willDelete) {
            data.splice(index, 1);
          }
        });
    }
  }
};
